import { AgelessAssessmentFlowType } from "@/core/api/orval/model/agelessAssessmentFlowType";
import type { DataPrivacyRegion } from "@/core/api/orval/model/dataPrivacyRegion";
import { assessmentSessionStorageService } from "@/features/assessments/AssessmentSessionStorageService";
import { getAssessmentCaptureConsentTextVersion } from "@/features/assessments/consent/regionalConsent";
import {
  captureAssessmentBiometricConsent,
  captureAssessmentConsumerHealthConsent,
  captureAssessmentPromotionalMarketingConsent,
} from "@orval/ageless-consent/ageless-consent";

export function hasAssessmentConsentInCache(
  assessmentId: string,
  flowType: AgelessAssessmentFlowType,
): boolean {
  return assessmentSessionStorageService.hasConsentCaptured(assessmentId, flowType);
}

export async function captureAssessmentConsents(
  assessmentId: string,
  flowType: AgelessAssessmentFlowType,
  consentLanguageCode: string,
  dataPrivacyRegion: DataPrivacyRegion,
  authRequestOptions?: { headers: HeadersInit },
): Promise<void> {
  const consentTextVersion = getAssessmentCaptureConsentTextVersion(flowType);

  const request = { consentTextVersion, consentLanguageCode, dataPrivacyRegion };

  await Promise.all([
    captureAssessmentBiometricConsent(assessmentId, request, authRequestOptions),
    captureAssessmentConsumerHealthConsent(assessmentId, request, authRequestOptions),
    captureAssessmentPromotionalMarketingConsent(assessmentId, request, authRequestOptions),
  ]);

  assessmentSessionStorageService.markConsentCaptured(assessmentId, flowType);
}
